<template>
  <section class="cool-navigate-header" :style="navigateStyle">
    <div class="cool-nav">
      <div class="back-btn btn" @click="goBack" v-show="hasBack">
        <i class="iconfont etc-icon-arrow-left"></i>
      </div>
      <span>{{title}}</span>
      <slot name="rightBtn"></slot>
    </div>
  </section>
</template>

<script>

export default {
  name: 'navigateHeader',
  mixins: [],
  components: {},
  props: {
    specialBack: [Boolean, String],
    title: {
      type: String,
      default: 'ETC助手'
    },
    hasBack: [Boolean, String],
    navigateStyle: Object
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    goBack() {
      if (!this.specialBack) {
        this.$router.back()
      } else {
        this.$emit('goSpecialBack')
      }
    }
  },
  mounted() {
    this.$on('changeHeaderBG', (color) => {
      // console.log('changeHeaderBG', color)
      this.navigateStyle['background-color'] = color
    })
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.cool-navigate-header{
  width: 100%;
  color: #333333;
  font-size: 34px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: #fff;
  .cool-nav{
    height: 88px;
    position: relative;
  }
  .btn{
    padding: 0 20px;
    height: 100%;
    @extend %flex-center;
  }
  .back-btn{
    float: left;
  }
  span{
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    @extend %flex-center;
  }
}
</style>
